<template>
  <blank-view :bodyStyle="{padding:'6px'}" ref="wrapper">
    <div slot="action" style="display:flex;flex-direction: row">
      <a-button style="margin-right:10px" @click="openModal">{{$t("page_terminal_choose")}}</a-button>
    </div>

    <terminal-view v-if="selectGateway"
        ref="terminalView"
        style="height:100%"
        :selectGateway="selectGateway"
        :getToken="getToken"
        :userName="userName"
        :baseUrl="baseUrl"
    ></terminal-view>

<!--    <div v-if="selectGateway" ref="terminal" style="width:100%;height:100%;background:#000">-->
<!--      <div style="width:100%;height:100%"></div>-->
<!--    </div>-->
    <div style="height:100%;display:flex;align-items:center;justify-content:center" v-else>
      <a-empty :description="$t('page_terminal_choose_tip')" />
    </div>
    <a-modal v-model="visible" :title="$t('page_terminal_choose')" @ok="saveGateway">
      <div style="display:flex;justify-content:center;align-items:center;margin-bottom:20px">
        <span style="margin-right:8px">{{$t("page_tenant_list")}}:</span>
        <app-select placeholder="请选择租户" :list="tenants" v-model="selectTenant" :show-search="true" @changeSelect="getData"
                    style="width:300px;"/>
      </div>
      <div style="display:flex;justify-content:center;align-items:center">
        <span style="margin-right:8px">{{$t("page_terminal_gateways")}}:</span>
        <a-select :showSearch="true" style="width:300px" v-model="selectValue">
          <a-select-option
            v-for="(item,index) in gateways"
            :key="index"
            :value="item.sn"
          >{{item.sn}}</a-select-option>
        </a-select>
      </div>
    </a-modal>

  </blank-view>
</template>

<script>

import { ConsoleGatewayServiceProxy } from "@/service-proxies/app-v2/console.service-proxies";
import { MasterlinkTenantServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import {
  GatewayServiceProxy ,
} from '@/service-proxies/app-v2/iot-console.service-proxies'
import TerminalView from "./component/TerminalView";
const systemService = new MasterlinkTenantServiceProxy();
const service = new ConsoleGatewayServiceProxy();
const igsp = new GatewayServiceProxy();
import { getToken, getUserInfo } from "@/utils/auth";
const BASE_URL = window.TERMINAL_URL;
export default {
  components: {TerminalView},
  data() {
    return {
      gateways: [],
      visible: false,
      selectGateway: "",
      selectValue: "",
      tenants: [],
      selectTenant: null,
      getToken : getToken(),
      userName : getUserInfo().user_name,
      baseUrl : BASE_URL,
    };
  },
  async mounted() {
    this.getTenants()
  },

  methods: {
     async getData() {
       let path = this.$route.path
       if(~path.indexOf('iot-console')) {
         let params = {
           current: 1,
           filter: '',
           size: -1,
           tenantId: this.selectTenant,
           isOnline: undefined,
           batchCode: undefined,
           ascs: undefined,
           descs: undefined
         }
         let { items } = await igsp.findGatewayList(params)
         this.gateways = items.map((item) => ({
           sn: item.code,
         }));
       } else {
         const { records } = await service.queryGatewayList(1, false, undefined, -1, this.selectTenant);
         this.gateways = records.map((item) => ({
           sn: item.sn,
         }));
       }
     },
    async getTenants() {
      const {
        data: { records },
      } = await systemService.getTenants(undefined, 1, -1, undefined, undefined);
      this.tenants = records.map(item => ({ label: item.tenantName, value: item.tenantId }))
    },
    openModal() {
      this.selectValue = this.selectGateway;
      this.visible = true;
    },

    saveGateway() {
      this.selectGateway = this.selectValue;
      this.visible = false;
      this.$nextTick(() => {
        this.$refs.terminalView.init();
      });
    },



  },
};
</script>

<style lang="less">
</style>
